import { render } from "./CriticalMotionDates.vue?vue&type=template&id=05d903d0&scoped=true"
import script from "./CriticalMotionDates.vue?vue&type=script&lang=js"
export * from "./CriticalMotionDates.vue?vue&type=script&lang=js"

import "./CriticalMotionDates.vue?vue&type=style&index=0&id=05d903d0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d903d0"]])

export default __exports__